/**
 * Die Marke an einem Artikel-Suchtreffer der Anlagemaske: "Verknüpft" bzw. "Nicht verknüpft" mit
 * dem GEWAEHLTEN Lieferanten (`sucheArtikel(..., kLieferant)`, `backend/src/jtl/artikel.ts:167`,
 * JOIN gegen `tliefartikel`) - und bei fehlendem Lieferantenkontext NICHTS (`null`).
 *
 * ============================== EINE FUNKTION, KEINE KOMPONENTE ==============================
 *
 * Nach demselben Muster wie `Suppliers/AktivMarke.tsx` (Kopfkommentar dort, woertlich): eine
 * Funktion `verknuepftMarke(...)` LIEFERT `null`, waehrend ein `<VerknuepftMarke />` immer ein
 * wahrheitswertiges React-Element waere - der Aufrufer entscheidet am Rueckgabewert, ob er
 * ueberhaupt eine Huelle zeichnet ("`null` heisst kein Zusatz an DIESEM Treffer").
 *
 * ================= ANDERS ALS `aktivMarke`: HIER BLEIBT DER GUTE FALL NICHT UNMARKIERT =================
 *
 * `aktivMarke` markiert nur die AUSNAHME (inaktiv/unbekannt), weil der gute Fall (aktiv) in einer
 * Lieferantensuche die Regel ist - stuende ueberall "aktiv", faele die Marke nicht mehr auf.
 *
 * Hier gilt das NICHT: `sucheArtikel` mit `kLieferant` durchsucht weiterhin ALLE aktiven
 * JTL-Artikel (`ARTIKEL_SUCHEN_JE_LIEFERANT`), nicht nur die des gewaehlten Lieferanten - der
 * unverknuepfte Fall ist in einer Trefferliste eher die REGEL als die Ausnahme. "Nur die Ausnahme
 * markieren" wuerde hier also fast jede Zeile markieren und die eigentliche Ausnahme (den
 * verknuepften Treffer) unmarkiert lassen - das genaue Gegenteil des Zwecks einer Marke. Deshalb
 * bekommen BEIDE bekannten Zustaende (`true`/`false`) eine eigene, unterscheidbare Marke.
 *
 * `null`/`undefined` (kein Lieferant gewaehlt bzw. Aufrufer ohne Lieferantenkontext) bleibt
 * unmarkiert, wie bei `aktivMarke`: ohne gewaehlten Lieferanten gibt es schlicht nichts zu melden.
 */
import type { JSX } from "react";

/**
 * `verknuepft` ist der ROHE Wert des Treffers (`boolean | null | undefined`) - eingeordnet wird
 * hier, nicht beim Aufrufer. `null`/`undefined` heisst "an diesem Treffer ist nichts zu melden".
 */
export function verknuepftMarke(verknuepft: boolean | null | undefined): JSX.Element | null {
  if (verknuepft === true) return <span className="jtl-treffer-marke verknuepft">Verknüpft</span>;
  if (verknuepft === false)
    return <span className="jtl-treffer-marke nicht-verknuepft">Nicht verknüpft</span>;
  return null;
}
